var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("Header", {
        attrs: { "is-menu-mini": _vm.isMenuMini },
        on: {
          "mini-click": function($event) {
            _vm.isMenuMini = !_vm.isMenuMini
          },
          "mobile-menu-click": function($event) {
            _vm.isMobileMenuOpen = !_vm.isMobileMenuOpen
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "layout-wrapper" },
        [
          _c("Menu", {
            staticClass: "layout-wrapper-nav",
            attrs: { menu: _vm.menu, "is-menu-mini": _vm.isMenuMini }
          }),
          _vm._v(" "),
          _c("MobileMenu", {
            attrs: { menu: _vm.menu },
            model: {
              value: _vm.isMobileMenuOpen,
              callback: function($$v) {
                _vm.isMobileMenuOpen = $$v
              },
              expression: "isMobileMenuOpen"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "layout-content" }, [
            _c("div", { attrs: { id: "content" } }, [_c("router-view")], 1)
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }